<template>
    <v-container fluid>

     <v-card class="ma-3">
        <v-card-title>
          <h4 class="subheading grey--text">Φίλτρα</h4>
          <v-spacer/>
        </v-card-title>
      <v-card-text>
        <v-row>
        <v-combobox
          v-model="manf"
          v-if="false"
          :items="uniqueManufacturers"
          prepend-icon="mdi-factory"
          label="Κατασκευαστής"
          chips
          multiple
          clearable
        >
          <template v-slot:selection="{ attrs, item, select, selected }">
            <v-chip
              v-bind="attrs"
              :input-value="selected"
              close
              @click="select"
              @click:close="remove(manf, item)"
            >
              <strong>{{ item }}</strong>&nbsp;
            </v-chip>
          </template>
        </v-combobox>
        <v-col cols="12" sm="4">
        <v-combobox
          v-model="supplier"
          :items="uniqueSuppliers"
          prepend-icon="mdi-warehouse"
          label="Προμηθευτής"
          clearable
          item.value="Name"
          multiple
        >
          <template v-slot:selection="{ attrs, item }">
            {{ item.Name }}
          </template>
          <template v-slot:item="data">
            <template v-if="typeof data.item !== 'object'">
              <v-list-item-content v-text="data.item"></v-list-item-content>
            </template>
            <template v-else>
              <v-list-item-content>
                <v-list-item-title v-html="data.item.Name"></v-list-item-title>
                <v-list-item-subtitle v-html="data.item.Address"></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </template>
        </v-combobox>
        </v-col>
            <v-col>
            <v-badge
              class="ma-2"
              overlap
              color="secondary"
              :content="totalQtyByYear"
            >
             <v-chip outlined class="px-4 ma-0"><v-icon>mdi-cart</v-icon></v-chip>
            </v-badge>

            </v-col>
             <v-col cols="12" sm="4">
            <v-select
                v-model="invoicingPeriod"
                :items="uniqueInvoiceYears"
                :suffix="fiDate"
                label="Έτος χρήσης"
                prepend-icon="mdi-calendar"
                clearable
              ></v-select>
            </v-col>
        </v-row>
      </v-card-text>
    <v-card-actions>
    <!-- Display v-chips for Manufacturers -->
    <v-row>
       <v-col
          v-for="manufacturer in uniqueManufacturers"
          :key="manufacturer"
          cols="auto"
          class="d-flex justify-center"
        >
            <v-badge
              color="secondary"
              :content="manufacturerQtyByYear(manufacturer)"
              overlap
            >
          <v-chip
            class="pa-4"
            :color="manfSelected(manufacturer) ? 'primary' : 'grey lighten-1'"
            @click="toggleManufacturer(manufacturer)"
          >
              <span class="mx-2">{{ manufacturer }}</span>
          </v-chip>
            </v-badge>
        </v-col>
    </v-row>
    </v-card-actions>
    </v-card>

  <v-card class="d-flex-column justify-space-between ma-3 mt-4"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Τιμολόγια</h1>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="orders"
      :search="search"
      loading: false
      sort-by="Invoice.Date"
      sort-desc
      multi-sort
      item-key="Id"
      class="elevation-1"
      :loading="loading"
      loading-text="Loading... Please wait"
      single-expand: true
      :expanded.sync="expanded"
    >

     <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          v-if="item.Invoice"
          @click.stop="showInvoice(item)"
        >
         <v-icon>mdi-information-variant</v-icon>
        </v-btn>
        <v-btn
          icon
          :to="{name: 'order-info', params: {id: item.Id}}"
        >
         <v-icon>mdi-dolly</v-icon>
        </v-btn>
        <v-btn
          icon
          @click="printLabels(item)"
        >
         <v-icon>mdi-sticker-outline</v-icon>
        </v-btn>
        <v-btn
          icon
          @click="generateLabel(item)"
        >
         <v-icon>mdi-sticker</v-icon>
        </v-btn>
        <v-dialog
                v-if="false"
                v-model="printDialog"
                persistent
                max-width="800px"
              >
                <template v-slot:activator="{on, attrs}">
                     <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on">
                      <v-icon dark>mdi-sticker-outline</v-icon>
                    </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">Εκτύπωση ετικέτας</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="label">
                    <v-container>
                      <v-row>

                      <v-col cols="4" sm="4" md=4>
                          <v-text-field
                            label="Ποσότητα"
                            v-model.number="labelQty"
                            type="number"
                            ></v-text-field>

                      </v-col>
                      <v-col cols="4" sm="4" md=4>
                          <v-text-field
                            label="Χρησιμοποιημένες*"
                            v-model.number="usedLabelQty"
                            type="number"
                            ></v-text-field>

                      </v-col>
                      </v-row>
                    </v-container>
                    <small>*indicates required field</small>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="printDialog = false"
                    >
                      Κλείσιμο
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="fetchLabel(item)"
                    > Εκτύπωση
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

     </template>

     <template v-slot:item.PartNetCost="{ item }">
       {{ $tocurr(item.PartNetCost) }}
    </template>
     <template v-slot:item.PartCost="{ item }">
       {{ $tocurr(item.PartCost) }}
    </template>
     <template v-slot:item.Invoice.Date="{ item }">
       <span v-if="item.Invoice">{{ item.Invoice.Date }}</span>
       <span v-else> {{ $fmtDate(item.Timestamp) }}</span>
    </template>
    <template v-slot:item.SuggestedPrice="{ item }">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
        >      {{ $tocurr(item.SuggestedPrice) }}</span>
      </template>
      <span>{{((item.SuggestedPrice/item.PartCost-1)*100).toFixed(0)}}% - {{$tocurr(item.SuggestedPrice-item.PartCost)}}</span>
    </v-tooltip>


    </template>

   <template v-slot:body.append="{headers}">
        <tr>
            <td v-for="(header,i) in headers" :key="i">
                <div class="text-right"  v-if="header.value == 'PartNetCost'">
                  Σύνολο:  {{ $tocurr($sumField(orders, 'PartNetCost')) }}
                </div>
                <div class="text-right"  v-if="header.value == 'PartCost'">
                  {{ $tocurr($sumField(orders, 'PartCost')) }}
                </div>
                <div class="text-right"  v-if="header.value == 'Qty'">
                  {{ $sumField(orders, 'Qty') }}
                </div>
                <div class="text-right"  v-if="header.value == 'StockQty'">
                  {{ $sumField(orders, 'StockQty') }}
                </div>

                <div v-else>
                    <!-- empty table cells for columns that don't need a sum -->
                </div>

            </td>
        </tr>
    </template>

     <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        Σημειώσεις: {{ item.Remarks }}<br>
      </td>
    </template>

    </v-data-table>
  </v-card>


    <PrintDialog
      :item="selectedItem"
      partOrder=true
      :showDialog="showLabelDialog"
      @close="handleDialogClose"
    />

    </v-container>
</template>

<script>
//import axios from 'axios';
import PrintDialog from '../../components/PrintLabelDialog.vue'

export default {
  components : {
    PrintDialog
  },
  data() {
    return {
      expanded: [],
      diaitems: {},
      loading: true,
      balance: 0.0,
      search: '',
      invoicingPeriod: null,
      printDialog: false,
      showLabelDialog: false,
      selectedItem: null, // Selected item for PrintLabelDialog
      manf: [], // Array to store selected manufacturers
      supplier: [], // Array to store selected supplier
      pid: this.$route.params.id,
      orders: [],
      part: {},
      headers: [
          {
            text: 'Αρ. Παρτίδας',
            align: 'start',
            //sortable: false,
            value: 'Id',
            width: '5%',
          },
          { text: 'Ημερομηνία', value: 'Invoice.Date', width: '10%',
            filter: (value) => {
              if (!this.invoicingPeriod) return true;
              if (this.invoicingPeriod == value.slice(0,4)) return true;
            },
          
          },
          { text: 'Σειρά', value: 'Invoice.SeriesCode' },
          { text: 'Αριθμός Τιμολογίου', value: 'Invoice.DocNumber' },
          { text: 'Προμηθευτής', value: 'Invoice.Supplier.Name',
            filter: (value) => {
                if (this.supplier.length == 0) return true;
                return this.supplier.includes(value);
                }
        
          },
          { text: 'Κωδικός Προμ.', value: 'SupplierSku' },
          { text: 'Κατασκευαστής', value: 'Manufacturer', groupable: true,
            filter: (value) => {
                if (this.manf.length == 0) return true;
                return this.manf.includes(value);
                }
          },
          { text: 'Νέτη', value: 'PartNetCost', align: 'end' },
          { text: 'Aξία', value: 'PartCost', align: 'end' },
          { text: 'Ποσότητα', value: 'Qty', align: 'end' },
          { text: 'Απόθεμα', value: 'StockQty', align: 'end' },
          { text: 'Τιμή Πώλησης', value: 'SuggestedPrice', align: 'end' },
          { text: 'Actions', value: 'actions' },
          { text: '', value: 'data-table-expand' },
        ],
    }
  },
  async created() {
      try {
        const response = await this.$api.get('/inventory/parts/info/'+this.$route.params.id);
        // console.log(response);
        this.part = response.data;
        this.orders = this.part.Orders;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {

},
computed: {
 uniqueManufacturers () {
      // console.log("asdsd: ", this.uniq(this.invoices, "PlateNumber"));
      return this.uniq(this.orders, 'Manufacturer');
    },
  uniqueSuppliers () {
    return this.uniqSup(this.orders);
  },
  uniqueInvoiceYears () {
    // console.log("asdsd: ", this.uniq(this.invoices, "PlateNumber"));
    return this.uniqYears(this.orders);
  },
  totalQtyByYear() {
     if (this.invoicingPeriod) return this.orders.filter(order => order.Timestamp.slice(0,4) == this.invoicingPeriod).reduce((acc, order) => acc + order.Qty, 0)
     return this.orders.reduce((acc, order) => acc + order.Qty, 0)
  },
  fiDate() {
    if (!this.invoicingPeriod) return;
    return this.$tocurr(this.$sumField(this.orders.filter(order=> order.Timestamp.slice(0,4)==this.invoicingPeriod), 'PartNetCost'))
  },
},
methods: {
  uniqYears(items) {
    //Store the unique
    let uniques = [];

    //Track the items added to the uniques
    let itemsFound = {};
    let year = 0;
    for (let val of items) {
      year = val['Timestamp'].slice(0,4);
      //console.log(year) //.getFullYear();
      //If item is already added then move to the next item
      if (itemsFound[val[year]]) {
        continue;
      }

      //Else push it to the unique list
      uniques.push(year);

      //Mark it as added
      itemsFound[year] = true;
    }

    //Return the uniques
    return uniques;
  },
  tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
  showOrder(item) {
    let path = "Order"
    let params = {"id": item.Id}
    this.$router.push({"name": path, "params": params});
  },
  showInvoice(item) {
     let path = "distributor-order-checkin"
    let params = {"invoiceId": item.InvoiceId}
    this.$router.push({"name": path, "params": params});
  },
  generateFilename(item) {
    const { Id, Manufacturer, FmSku } = item;
    return `Order-ID${Id}-${Manufacturer}-${FmSku}.png`;
  },
  manfSelected (manufacturer) {
    if (this.manf.length == 0) return true;
    return this.manf.includes(manufacturer);
  },
  toggleManufacturer(manufacturer) {
      if (this.manf.includes(manufacturer)) {
        this.manf = this.manf.filter(m => m !== manufacturer);
      } else {
          this.manf.push(manufacturer);
      }
  },
  manufacturerQtyByYear(manufacturer) {
    if (this.invoicingPeriod) return this.orders.filter(order => order.Timestamp.slice(0,4) == this.invoicingPeriod).filter(order => order.Manufacturer == manufacturer).reduce((acc, order) => acc + order.Qty, 0)
    return this.orders.filter(order => order.Manufacturer == manufacturer).reduce((acc, order) => acc + order.Qty, 0)
  },
  remove(obj, item) {
    obj.splice(obj.indexOf(item), 1);
    obj.manf = [...obj];
  },

  uniqSup(items) {
    //Store the unique
    let uniques = [];

    //Track the items added to the uniques
    let itemsFound = {};
    let supp = null;
    for (let val of items) {
      //If no invoice, skip
      if (val.Invoice) {
        //If item is already added then move to the next item
        supp = val.Invoice.Supplier
        if (itemsFound[supp.Id]) {
          continue;
        }

        //Else push it to the unique list
        uniques.push(supp);

        //Mark it as added
        itemsFound[supp.Id] = true;

      }
    }

    //Return the uniques
    return uniques;
  },
  uniq(items, key) {
    //Store the unique
    let uniques = [];

    //Track the items added to the uniques
    let itemsFound = {};
    for (let val of items) {
      //If item is already added then move to the next item
      if (itemsFound[val[key]]) {
        continue;
      }

      //Else push it to the unique list
      uniques.push(val[key]);

      //Mark it as added
      itemsFound[val[key]] = true;
    }

    //Return the uniques
    return uniques;
  },
  generateLabel(item) {
    this.selectedItem = item;
    this.showLabelDialog = true;
  },
  handleDialogClose () {
    this.showLabelDialog = false;
  },
  async printLabels(item) {
      const options = {
        method: 'GET',
        params: {qty: this.labelQty, start_from: this.usedLabelQty, filetype: "png"},
        url: '/inventory/printlabel/'+item.Id,
        responseType: "blob",
      };


        this.$api(options).then((response) => {
        let url = window['URL'].createObjectURL(response.data)
        var a = document.createElement('a')
        a.href = url
        a.download = this.generateFilename(item);
        a.click()
        a.remove()
        setTimeout(() => window.URL.revokeObjectURL(url), 100)
      })
      .then(() => {
        // alert('File saved succesfully');
      })
      .catch((error) => {
        console.log(error);
      });

      },

    }
  }
</script>
